export default __webpack_public_path__ + "static/media/main_all_background.02689a03.jpg";